import React, { useState } from 'react';
import { IoSparkles, IoInformationCircleOutline } from 'react-icons/io5';
import { useFamilyData } from '@/hooks/useFamilyData';
import './FamilyDescriptionBox.css';

interface FamilyDescriptionBoxProps {
  onAnalysisComplete?: () => void;
}

const FamilyDescriptionBox: React.FC<FamilyDescriptionBoxProps> = ({ onAnalysisComplete }) => {
  const [description, setDescription] = useState('');
  const { analyzeFamilyDescription, isAnalyzing } = useFamilyData();

  const handleAnalyze = async () => {
    const result = await analyzeFamilyDescription(description);
    if (result && onAnalysisComplete) {
      onAnalysisComplete();
    }
  };

  const exampleDescriptions = [
    "My mom Sarah is a nurse at City Hospital and went to UCLA. My dad Mike is a software engineer at Google with a CS degree from Stanford. I have a younger sister Emma who's 16.",
    "My parents divorced when I was 10. My mom is a teacher and remarried my stepdad John who's a lawyer. My dad lives in another state and works in marketing.",
    "I live with my grandmother who raised me. She worked as a librarian before retiring. My mom passed away when I was young."
  ];

  return (
    <div className="family-description-box">
      <div className="family-description-header">
        <div className="family-description-title">
          <IoSparkles className="family-description-icon" />
          <h3>Tell us about your family</h3>
        </div>
        <div className="family-description-subtitle">
          Describe your family in your own words - we'll organize the information for you
        </div>
      </div>

      <div className="family-description-content">
        <textarea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Tell us about your parents, siblings, their jobs, education, and any other family details..."
          className="family-description-textarea"
          rows={6}
          disabled={isAnalyzing}
        />

        <div className="family-description-actions">
          <button
            onClick={handleAnalyze}
            disabled={!description.trim() || isAnalyzing}
            className="family-description-analyze-btn"
          >
            {isAnalyzing ? (
              <>
                <div className="family-description-spinner" />
                Analyzing...
              </>
            ) : (
              <>
                <IoSparkles />
                Analyze Family Information
              </>
            )}
          </button>
        </div>

        <div className="family-description-help">
          <div className="family-description-help-header">
            <IoInformationCircleOutline />
            <span>Need help getting started?</span>
          </div>
          <div className="family-description-examples">
            <p>Here are some examples:</p>
            {exampleDescriptions.map((example, index) => (
              <div
                key={index}
                className="family-description-example"
                onClick={() => setDescription(example)}
              >
                "{example}"
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FamilyDescriptionBox;